export const SalesPage = () => {
  return (
    <>
      <div>This is sales</div>
    </>
  );
};
